import { MAX_WIDTH_MOBILE, MAX_WIDTH_TABLET } from "./dimension";

const Colors = {
  Primary: "#1877EB",

  //------------- Text -------------
  TextDefault: "#FFFFFF",
  TextSecondary: "#000000",
  TextGray: "#8D8D8D",
  TextDisable: "#6A6A6A",
  TextSilver: "#C0C0C0",
  TextCharcoal: "#505050",
  TextGraphite: "#303030",

  //------------- Button -------------
  ButtonDisable: "#3F3F3F",

  //------------- Border -------------
  Border1: "rgba(255, 255, 255, 0.20)",
  Border2: "rgba(255, 255, 255, 0.40)",
  Border3: "rgba(255, 255, 255, 0.60)",
  Border4: "rgba(255, 255, 255, 0.80)",

  //------------- Functional Color -------------
  NotificationError: "#EE4E42",
  NotificationSuccess: "#3CB84E",
  NotificationWarning: "#FAA356",

  //------------- Backgrounds -------------
  Background: "#3F3F3F",
  Background1: "#141414",
  Background2: "#1B1B1B",
  Background3: "#222222",
  Background4: "#343434",
};

const Radius = {
  button: 2,
  sSmall: 4,
  small: 8,
  medium: 16,
  large: 24,
};

const Spacing = {
  space2: 2,
  space4: 4,
  space6: 6,
  space8: 8,
  space12: 12,
  space16: 16,
  space18: 18,
  space20: 20,
  space22: 22,
  space24: 24,
  space32: 32,
  space36: 36,
  space40: 40,
  space48: 48,
};

const FontWeight = {
  bold: 700,
  semiBold: 600,
  medium: 500,
  regular: 400,
};

const ZIndex = {
  normal: 1,
  appBar: 110,
  dialog: 1900,
};

const mediaQueries = {
  mobile: `@media (max-width: ${MAX_WIDTH_MOBILE}px)`,
  tablet: `@media (min-width: ${MAX_WIDTH_MOBILE + 1}px) and (max-width: ${MAX_WIDTH_TABLET}px)`,
  desktop: `@media (min-width: ${MAX_WIDTH_TABLET + 1}px)`,
};

export const DefaultTheme = {
  colors: Colors,
  radius: Radius,
  spacing: Spacing,
  fontWeight: FontWeight,
  zIndex: ZIndex,
  mediaQueries: mediaQueries,
};

export type ITheme = typeof DefaultTheme;
